import { deleteData, getData, postData, putData } from "./APIServiceInterface";

export const getDiscountService = async () => {
  const response = await getData("/discount/get");
  return response;
};

export const getTransactionTypeService = async () => {
  const response = await getData("/transactionType/get");
  return response;
};

export const createDiscountService = async (payload) => {
  const response = await putData("/discount/create", payload);
  return response;
};

export const updateDiscountService = async (id, payload) => {
  return await postData(`/discount/update?discountId=${id}`, payload);
};

export const deleteDiscountService = async (payload) => {
  return await deleteData(`/discount/delete?discountId=${payload}`);
};

